import cn from 'classnames';

import { Add } from '@webapp/common/assets/icons';

import css from './add-round.css';

export const AddRound: FC<{
    onClick: (e: any) => void;
    title?: string;
    className?: string;
}> = ({ className, onClick, title }) => (
    <div className={cn(css.add, className)} title={title}>
        <div className={css.btn} onClick={onClick}>
            <Add />
        </div>
    </div>
);
